module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0160.jpg?v=5dc0f53f";